var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C6.81818 0 1.96591 3.31733 0 8C1.96591 12.6827 6.81818 16 12.5 16C18.1818 16 23.0341 12.6827 25 8C23.0341 3.31733 18.1818 0 12.5 0ZM12.5 13.3333C9.36364 13.3333 6.81818 10.944 6.81818 8C6.81818 5.056 9.36364 2.66667 12.5 2.66667C15.6364 2.66667 18.1818 5.056 18.1818 8C18.1818 10.944 15.6364 13.3333 12.5 13.3333ZM12.5 4.8C10.6136 4.8 9.09091 6.22933 9.09091 8C9.09091 9.77067 10.6136 11.2 12.5 11.2C14.3864 11.2 15.9091 9.77067 15.9091 8C15.9091 6.22933 14.3864 4.8 12.5 4.8Z",
    fill: "#8C8E86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.3fd3f1703b19c140cb197ca857907ea0.svg";
export { ForwardRef as ReactComponent };